import { render, staticRenderFns } from "./TitleSection.vue?vue&type=template&id=dc676de2&"
import script from "./TitleSection.vue?vue&type=script&lang=js&"
export * from "./TitleSection.vue?vue&type=script&lang=js&"
import style0 from "./TitleSection.vue?vue&type=style&index=0&id=dc676de2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports